import { FunctionComponent, MouseEvent, useEffect, useState } from 'react'
import { AppBar, Box, IconButton, Menu, MenuItem, Toolbar } from '@mui/material'
import AccountCircle from '@mui/icons-material/AccountCircle'
import LanguageIcon from '@mui/icons-material/Language'
import i18next from 'i18n'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import axiosInstance from 'store/axiosInstance'
import useLocalStorage from 'hooks/useLocalStorage'

export const HEADER_HEIGHT = 64

export const Header: FunctionComponent = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [langAnchorEl, setLangAnchorEl] = useState<null | HTMLElement>(null)
  const handleMenuClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const [lang, setLang] = useLocalStorage('lang', i18next.language)

  const handleLangClick = (event: MouseEvent<HTMLElement>) => {
    setLangAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleLangClose = () => {
    setLangAnchorEl(null)
  }

  const handleLangSelect = (lang: string) => {
    void i18next.changeLanguage(lang)
    setLang(lang)
    handleLangClose()
  }

  const handleNavigate = (link: string) => {
    navigate(link)
    setAnchorEl(null)
  }

  const handleLogoutClick = () => {
    axiosInstance.post('/auth/logout')
    handleNavigate('/')
  }

  useEffect(() => {
    void i18next.changeLanguage(lang)
  }, [lang])

  return (
    <AppBar position="static" sx={{ height: HEADER_HEIGHT }}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <div></div>
        <Box display="flex" alignItems="center">
          <Box mr={1}>
            <IconButton
              size="medium"
              aria-label="Language"
              aria-controls="menu-language"
              aria-haspopup="true"
              onClick={handleLangClick}
              color="inherit"
            >
              <LanguageIcon />
            </IconButton>
            <Menu
              id="menu-language"
              anchorEl={langAnchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(langAnchorEl)}
              onClose={handleLangClose}
            >
              <MenuItem
                sx={{
                  background: i18next.language === 'az' ? 'rgba(0, 0, 0, .2)' : '',
                }}
                onClick={() => handleLangSelect('az')}
              >
                Aze
              </MenuItem>
              <MenuItem
                sx={{
                  background: i18next.language === 'en' ? 'rgba(0, 0, 0, .2)' : '',
                }}
                onClick={() => handleLangSelect('en')}
              >
                Eng
              </MenuItem>
            </Menu>
          </Box>
          <Box>
            <IconButton
              size="medium"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenuClick}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={() => handleNavigate('/portal/settings')}>
                {t('myProfile')}
              </MenuItem>
              <MenuItem onClick={handleLogoutClick}>{t('logout')}</MenuItem>
            </Menu>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  )
}
